import * as tslib_1 from "tslib";
import { GL_TextureBase } from "./GL_TextureBase";
/**
 *
 * @class away.pool.TextureDataBase
 */
var GL_SingleCubeTexture = (function (_super) {
    tslib_1.__extends(GL_SingleCubeTexture, _super);
    function GL_SingleCubeTexture(singleCubeTexture, shader) {
        var _this = _super.call(this, singleCubeTexture, shader) || this;
        _this._singleCubeTexture = singleCubeTexture;
        return _this;
    }
    GL_SingleCubeTexture.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._singleCubeTexture = null;
    };
    GL_SingleCubeTexture.prototype._includeDependencies = function (includeInput) {
        if (includeInput === void 0) { includeInput = true; }
        if (includeInput)
            this._shader.usesPositionFragment = true;
    };
    /**
     *
     * @param shader
     * @param regCache
     * @param targetReg The register in which to store the sampled colour.
     * @param uvReg The direction vector with which to sample the cube map.
     * @returns {string}
     * @private
     */
    GL_SingleCubeTexture.prototype._getFragmentCode = function (targetReg, regCache, sharedReg, inputReg) {
        var format = ""; //this.getFormatString(this._singleCubeTexture.imageCube);
        var filter = "linear,miplinear";
        this._imageIndex = this._shader.getImageIndex(this._singleCubeTexture, 0);
        var textureReg = this.getTextureReg(this._imageIndex, regCache, sharedReg);
        this._textureIndex = textureReg.index;
        return "tex " + targetReg + ", " + inputReg + ", " + textureReg + " <cube," + format + filter + ">\n";
    };
    GL_SingleCubeTexture.prototype.activate = function () {
        var sampler = this._shader.pass.samplers[this._imageIndex];
        if (sampler)
            sampler.activate(this._textureIndex);
        if (this._shader.pass.images[this._imageIndex])
            this._shader.pass.images[this._imageIndex].activate(this._textureIndex, sampler._sampler.mipmap);
    };
    GL_SingleCubeTexture.prototype._setRenderState = function (renderable) {
        var sampler = renderable.samplers[this._imageIndex];
        if (sampler)
            sampler.activate(this._textureIndex);
        if (renderable.images[this._imageIndex] && sampler)
            renderable.images[this._imageIndex].activate(this._textureIndex, sampler._sampler.mipmap);
    };
    return GL_SingleCubeTexture;
}(GL_TextureBase));
export { GL_SingleCubeTexture };



// WEBPACK FOOTER //
// ../dist/lib/textures/GL_SingleCubeTexture.js